import React from 'react';
import WaybillQueryContent from './WaybillQueryContent';

function WaybillQuery() {
  return <WaybillQueryContent />;
}

export default WaybillQuery;
